import React, { Component } from 'react';
import BackToTop from './BackToTop';

class BackToTopContainer extends Component {
  constructor() {
    super();
    this.state = { visible: false };

    this._onScrollHandler = this._onScrollHandler.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this._onScrollHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._onScrollHandler);
  }

  render() {
    return this.state.visible && <BackToTop onTapBackToTop={this._onTapBackToTop} />;
  }

  _onScrollHandler() {
    const scrollTop =
      window.pageYOffset !== undefined
        ? window.pageYOffset
        : (document.documentElement || document.body.parentNode || document.body).scrollTop;

    if (scrollTop > 100 && !this.state.visible) {
      this.setState({ visible: true });
      return;
    }

    if (scrollTop <= 100 && this.state.visible) {
      this.setState({ visible: false });
      return;
    }
  }

  _onTapBackToTop() {
    window.scrollTo(0, 0);
  }
}

export default BackToTopContainer;
